/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_LabelInputs */

const en_nav_language_label = /** @type {(inputs: Nav_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const lv_nav_language_label = /** @type {(inputs: Nav_Language_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valoda`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Nav_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const nav_language_label = /** @type {((inputs?: Nav_Language_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_nav_language_label(inputs)
	return en_nav_language_label(inputs)
});